// Please keep this list in sync with
// https://git.corp.stripe.com/stripe-internal/pay-server/blob/0e37ce455a568176b39e66853e0e327380bd583d/lib/utils/email_address/_impl.rb#L161
export const DISPOSABLE_DOMAINS = new Set([
  '0-mail.com',
  '0815.ru',
  '0clickemail.com',
  '0wnd.net',
  '0wnd.org',
  '10mail.org',
  '10minutemail.com',
  '20mail.it',
  '20minutemail.com',
  '2prong.com',
  '30minutemail.com',
  '33mail.com',
  '3d-painting.com',
  '4warding.com',
  '4warding.net',
  '4warding.org',
  '60minutemail.com',
  '675hosting.com',
  '675hosting.net',
  '675hosting.org',
  '6ip.us',
  '6paq.com',
  '6url.com',
  '75hosting.com',
  '75hosting.net',
  '75hosting.org',
  '7tags.com',
  '9ox.net',
  'a-bc.net',
  'abyssmail.com',
  'acentri.com',
  'advantimo.com',
  'afrobacon.com',
  'ajaxapp.net',
  'amail.com',
  'amilegit.com',
  'amiri.net',
  'amiriindustries.com',
  'anappthat.com',
  'anonbox.net',
  'anonymbox.com',
  'any.pink',
  'antichef.com',
  'antichef.net',
  'antispam.de',
  'appixie.com',
  'armyspy.com',
  'aver.com',
  'azmeil.tk',
  'baxomale.ht.cx',
  'beddly.com',
  'beefmilk.com',
  'binkmail.com',
  'bio-muesli.net',
  'bladesmail.net',
  'bobmail.info',
  'bodhi.lawlita.com',
  'bofthew.com',
  'bootybay.de',
  'boun.cr',
  'bouncr.com',
  'boximail.com',
  'brefmail.com',
  'brennendesreich.de',
  'broadbandninja.com',
  'bsnow.net',
  'bugmenot.com',
  'bumpymail.com',
  'bund.us',
  'burstmail.info',
  'byom.de',
  'casualdx.com',
  'cbair.com',
  'centermail.com',
  'centermail.net',
  'chammy.info',
  'chitthi.in',
  'chogmail.com',
  'choicemail1.com',
  'clrmail.com',
  'coldemail.info',
  'cool.fr.nf',
  'correo.blogos.net',
  'cosmorph.com',
  'courriel.fr.nf',
  'courrieltemporaire.com',
  'cubiclink.com',
  'curryworld.de',
  'cust.in',
  'cuvox.de',
  'dacoolest.com',
  'daintly.com',
  'dandikmail.com',
  'dayrep.com',
  'deadaddress.com',
  'deadspam.com',
  'despam.it',
  'despammed.com',
  'devnullmail.com',
  'dfgh.net',
  'digitalsanctuary.com',
  'dingbone.com',
  'discard.email',
  'discardmail.com',
  'discardmail.de',
  'disposableaddress.com',
  'disposableemailaddresses.com',
  'disposableemailaddresses.emailmiser.com',
  'disposeamail.com',
  'disposemail.com',
  'dispostable.com',
  'divermail.com',
  'dm.w3internet.co.uk',
  'dm.w3internet.co.ukexample.com',
  'dodgeit.com',
  'dodgit.com',
  'dodgit.org',
  'dodsi.com',
  'doiea.com',
  'donemail.ru',
  'dontreg.com',
  'dontsendmespam.de',
  'drdrb.com',
  'drdrb.net',
  'droplar.com',
  'duam.net',
  'dump-email.info',
  'dumpandjunk.com',
  'dumpmail.de',
  'dumpyemail.com',
  'dx.ez.lv',
  'dx.linuxx.org',
  'e4ward.com',
  'eelmail.com',
  'einrot.com',
  'email60.com',
  'emaildienst.de',
  'emailias.com',
  'emailigo.de',
  'emailinfive.com',
  'emailmiser.com',
  'emailproxsy.com',
  'emailsensei.com',
  'emailtemporario.com.br',
  'emailto.de',
  'emailwarden.com',
  'emailx.at.hm',
  'emailxfer.com',
  'emeil.in',
  'emeil.ir',
  'emil.com',
  'emz.net',
  'enterto.com',
  'ephemail.net',
  'etranquil.com',
  'etranquil.net',
  'etranquil.org',
  'evopo.com',
  'explodemail.com',
  'fakeinbox.com',
  'fakeinformation.com',
  'fammix.com',
  'fastacura.com',
  'fastchevy.com',
  'fastchrysler.com',
  'fastkawasaki.com',
  'fastmazda.com',
  'fastmitsubishi.com',
  'fastnissan.com',
  'fastsubaru.com',
  'fastsuzuki.com',
  'fasttoyota.com',
  'fastyamaha.com',
  'fexbox.org',
  'fexpost.com',
  'fextemp.com',
  'filzmail.com',
  'fizmail.com',
  'fleckens.hu',
  'flurred.com',
  'fr33mail.info',
  'frapmail.com',
  'freeletter.me',
  'front14.org',
  'fudgerub.com',
  'fux0ringduh.com',
  'fw.moza.pl',
  'garliclife.com',
  'get1mail.com',
  'get2mail.fr',
  'getairmail.com',
  'getonemail.com',
  'getonemail.net',
  'ghosttexter.de',
  'girlsundertheinfluence.com',
  'gishpuppy.com',
  'go.irc.so',
  'gowikibooks.com',
  'gowikicampus.com',
  'gowikicars.com',
  'gowikifilms.com',
  'gowikigames.com',
  'gowikimusic.com',
  'gowikinetwork.com',
  'gowikitravel.com',
  'gowikitv.com',
  'grandmamail.com',
  'grandmasmail.com',
  'great-host.in',
  'greensloth.com',
  'grr.la',
  'gsrv.co.uk',
  'guerillamail.biz',
  'guerillamail.com',
  'guerillamail.net',
  'guerillamail.org',
  'guerrillamail.biz',
  'guerrillamail.com',
  'guerrillamail.de',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamailblock.com',
  'gustr.com',
  'h.mintemail.com',
  'h8s.org',
  'haltospam.com',
  'harakirimail.com',
  'hatespam.org',
  'hellodream.mobi',
  'hidemail.de',
  'hochsitze.com',
  'hopemail.biz',
  'hotpop.com',
  'hulapla.de',
  'ieatspam.eu',
  'ieatspam.info',
  'ieh-mail.de',
  'ihateyoualot.info',
  'iheartspam.org',
  'imails.info',
  'imgof.com',
  'inbax.tk',
  'inbox.si',
  'inboxalias.com',
  'inboxclean.com',
  'inboxclean.org',
  'inboxdesign.me',
  'inboxproxy.com',
  'inboxstore.me',
  'incognitomail.com',
  'incognitomail.net',
  'incognitomail.org',
  'insorg-mail.info',
  'ipoo.org',
  'irish2me.com',
  'iwi.net',
  'jetable.com',
  'jetable.fr.nf',
  'jetable.net',
  'jetable.org',
  'jnxjn.com',
  'jourrapide.com',
  'junk1e.com',
  'just4fun.me',
  'kasmail.com',
  'kaspop.com',
  'keepmymail.com',
  'killmail.com',
  'killmail.net',
  'kimsdisk.com',
  'kingsq.ga',
  'kir.ch.tc',
  'kksm.be',
  'klassmaster.com',
  'klassmaster.net',
  'kloap.com',
  'klzlk.com',
  'kmhow.com',
  'kook.ml',
  'koszmail.pl',
  'kulturbetrieb.info',
  'kurzepost.de',
  'lags.us',
  'lackmail.ru',
  'landmail.co',
  'lastmail.co',
  'lazyinbox.com',
  'lettrs.email',
  'letthemeatspam.com',
  'lhsdv.com',
  'lifebyfood.com',
  'link2mail.net',
  'litedrop.com',
  'login-email.ml',
  'lol.ovpn.to',
  'lookugly.com',
  'lopl.co.cc',
  'lortemail.dk',
  'lr78.com',
  'm4ilweb.info',
  'maboard.com',
  'mail-temporaire.fr',
  'mail.by',
  'mail.mezimages.net',
  'mail2rss.org',
  'mail333.com',
  'mail4trash.com',
  'mailbox.in.ua',
  'mailbidon.com',
  'mailblocks.com',
  'mailbox92.com',
  'mailcat.biz',
  'mailcatch.com',
  'maildrop.cc',
  'maileater.com',
  'mailexpire.com',
  'mailfa.tk',
  'mailfreeonline.com',
  'mailimate.com',
  'mailin8r.com',
  'mailinater.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator2.com',
  'mailincubator.com',
  'mailismagic.com',
  'mailmate.com',
  'mailme.ir',
  'mailme.lv',
  'mailmetrash.com',
  'mailmoat.com',
  'mailnator.com',
  'mailnesia.com',
  'mailnull.com',
  'mailosaur.in',
  'mailpick.biz',
  'mailproxsy.com',
  'mailrock.biz',
  'mailshell.com',
  'mailsiphon.com',
  'mailslite.com',
  'mailtemp.com',
  'mailtemp.info',
  'mailto.plus',
  'mailtothis.com',
  'mailzi.ru',
  'mailzilla.com',
  'mailzilla.org',
  'mailzilla.orgmbx.cc',
  'mbx.cc',
  'mega.zik.dj',
  'merepost.com',
  'meinspamschutz.de',
  'meltmail.com',
  'messagebeamer.de',
  'mierdamail.com',
  'mintemail.com',
  'moakt.com',
  'moburl.com',
  'mohmal.com',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'monumentmail.com',
  'msa.minsmail.com',
  'mt2009.com',
  'mt2014.com',
  'mx0.wwwnew.eu',
  'my10minutemail.com',
  'mycleaninbox.net',
  'mymailoasis.com',
  'mypartyclip.de',
  'myphantomemail.com',
  'myspaceinc.com',
  'myspaceinc.net',
  'myspaceinc.org',
  'myspacepimpedup.com',
  'myspamless.com',
  'mytrashmail.com',
  'neomailbox.com',
  'nepwk.com',
  'nervmich.net',
  'nervtmich.net',
  'netmails.com',
  'netmails.net',
  'netzidiot.de',
  'neverbox.com',
  'no-spam.ws',
  'nobulk.com',
  'noclickemail.com',
  'nogmailspam.info',
  'nomail.xl.cx',
  'nomail2me.com',
  'nomorespamemails.com',
  'nospam.ze.tc',
  'nospam4.us',
  'nospamfor.us',
  'nospamthanks.info',
  'notmailinator.com',
  'notsharingmy.info',
  'nowmymail.com',
  'nurfuerspam.de',
  'nwldx.com',
  'objectmail.com',
  'obobbo.com',
  'olypmall.ru',
  'one-time.email',
  'oneoffemail.com',
  'onewaymail.com',
  'online.ms',
  'oopi.org',
  'opayq.com',
  'ordinaryamerican.net',
  'otherinbox.com',
  'ourklips.com',
  'outlawspam.com',
  'ovpn.to',
  'owlpic.com',
  'pancakemail.com',
  'paplease.com',
  'pimpedupmyspace.com',
  'pjjkp.com',
  'plexolan.de',
  'politikerclub.de',
  'pooae.com',
  'poofy.org',
  'pookmail.com',
  'postonline.me',
  'privacy.net',
  'proxymail.eu',
  'prtnx.com',
  'punkass.com',
  'putthisinyourspamdatabase.com',
  'pwrby.com',
  'quickinbox.com',
  'quickmail.nl',
  'rcpt.at',
  'reallymymail.com',
  'recode.me',
  'recursor.net',
  'regbypass.com',
  'regbypass.comsafe-mail.net',
  'rejectmail.com',
  'rhyta.com',
  'rklips.com',
  'rmqkr.net',
  'rppkn.com',
  'rtrtr.com',
  'rover.info',
  's0ny.net',
  'safe-mail.net',
  'safersignup.de',
  'safetymail.info',
  'safetypost.de',
  'sandelf.de',
  'saynotospams.com',
  'selfdestructingmail.com',
  'sendspamhere.com',
  'sharedmailbox.org',
  'sharklasers.com',
  'shiftmail.com',
  'shitmail.de',
  'shitmail.me',
  'shortmail.net',
  'sibmail.com',
  'skeefmail.com',
  'slaskpost.se',
  'slopsbox.com',
  'smashmail.de',
  'smellfear.com',
  'smellrear.com',
  'snakemail.com',
  'sneakemail.com',
  'sofimail.com',
  'sofort-mail.de',
  'softpls.asia',
  'sogetthis.com',
  'solvemail.info',
  'soodonims.com',
  'spam.la',
  'spam.su',
  'spam4.me',
  'spamavert.com',
  'spambob.com',
  'spambob.net',
  'spambob.org',
  'spambog.com',
  'spambog.de',
  'spambog.net',
  'spambog.ru',
  'spambox.info',
  'spambox.irishspringrealty.com',
  'spambox.us',
  'spamcannon.com',
  'spamcannon.net',
  'spamcero.com',
  'spamcon.org',
  'spamcorptastic.com',
  'spamcowboy.com',
  'spamcowboy.net',
  'spamcowboy.org',
  'spamday.com',
  'spamex.com',
  'spamfree24.com',
  'spamfree24.de',
  'spamfree24.eu',
  'spamfree24.info',
  'spamfree24.net',
  'spamfree24.org',
  'spamgoes.in',
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  'spamherelots.com',
  'spamhereplease.com',
  'spamhole.com',
  'spamify.com',
  'spaminator.de',
  'spamkill.info',
  'spaml.com',
  'spaml.de',
  'spammotel.com',
  'spamobox.com',
  'spamoff.de',
  'spamslicer.com',
  'spamspot.com',
  'spamthis.co.uk',
  'spamthisplease.com',
  'spamtrail.com',
  'speed.1s.fr',
  'spikio.com',
  'spybox.de',
  'squizzy.de',
  'ssoia.com',
  'startkeys.com',
  'supergreatmail.com',
  'supermailer.jp',
  'superrito.com',
  'suremail.info',
  'tafmail.com',
  'tagyourself.com',
  'techgroup.me',
  'teewars.org',
  'teleworm.com',
  'teleworm.us',
  'temp-mail.de',
  'temp-mail.io',
  'temp-mail.org',
  'temp.headstrong.de',
  'tempalias.com',
  'tempe-mail.com',
  'tempemail.biz',
  'tempemail.com',
  'tempemail.net',
  'tempinbox.co.uk',
  'tempinbox.com',
  'tempmail.com',
  'tempmail.de',
  'tempmail.it',
  'tempmail2.com',
  'tempomail.fr',
  'temporarily.de',
  'temporarioemail.com.br',
  'temporaryemail.net',
  'temporaryforwarding.com',
  'temporaryinbox.com',
  'tempsky.com',
  'thanksnospam.info',
  'thankyou2010.com',
  'thecloudindex.com',
  'thisisnotmyrealemail.com',
  'throwawayemailaddress.com',
  'tilien.com',
  'tmail.ws',
  'tmailinator.com',
  'toiea.com',
  'toomail.biz',
  'tradermail.info',
  'trash-amil.com',
  'trash-mail.at',
  'trash-mail.com',
  'trash-mail.de',
  'trash2009.com',
  'trashemail.de',
  'trashmail.at',
  'trashmail.com',
  'trashmail.de',
  'trashmail.me',
  'trashmail.net',
  'trashmail.org',
  'trashmail.ws',
  'trashmailer.com',
  'trashymail.com',
  'trashymail.net',
  'trbvm.com',
  'trickmail.net',
  'trillianpro.com',
  'tryalert.com',
  'turual.com',
  'twinmail.de',
  'twoweirdtricks.com',
  'tyldd.com',
  'ubismail.net',
  'uggsrock.com',
  'upliftnow.com',
  'uplipht.com',
  'username.e4ward.com',
  'uu.gl',
  'valemail.net',
  'venompen.com',
  'veryrealemail.com',
  'viditag.com',
  'viewcastmedia.com',
  'viewcastmedia.net',
  'viewcastmedia.org',
  'vkcode.ru',
  'vomoto.com',
  'webm4il.info',
  'wee.my',
  'wegwerfadresse.de',
  'wegwerfemail.de',
  'wegwerfmail.de',
  'wegwerfmail.net',
  'wegwerfmail.org',
  'wetrainbayarea.com',
  'wetrainbayarea.org',
  'wh4f.org',
  'whatpaas.com',
  'whtjddn.33mail.com',
  'whyspam.me',
  'wickmail.net',
  'willselfdestruct.com',
  'winemaven.info',
  'wronghead.com',
  'wuzup.net',
  'wuzupmail.net',
  'www.e4ward.com',
  'www.gishpuppy.com',
  'www.mailinator.com',
  'wwwnew.eu',
  'xagloo.com',
  'xemaps.com',
  'xents.com',
  'xmaily.com',
  'xoxy.net',
  'yep.it',
  'yhg.biz',
  'yogamaven.com',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'ypmail.webarnak.fr.eu.org',
  'yuurok.com',
  'ze.gally.jp',
  'zehnminutenmail.de',
  'zetmail.com',
  'zippymail.info',
  'zoaxe.com',
  'zoemail.org',
  'zxcv.com',
  'zxcvbnm.com',
  'zzz.com',
  'knowledgemd.com',
  'candassociates.com',
  'newtempmail.com',
  'scpulse.com',
  'midiharmonica.com',
  'cutradition.com',
  'bsbvans.com.br',
  'arxxwalls.com',
  'bluebasketbooks.com.au',
  'sinaite.net',
  'vusra.com',
  'ifyourock.com',
  'nqmo.com',
  'duetube.com',
  'akapple.com',
  'cupbest.com',
  'doerma.com',
  'dakcans.com',
  'dufeed.com',
  'roxoas.com',
  'hbehs.com',
  'gotgel.org',
  'jollyfree.com',
  'rungel.net',
  'vintomaper.com',
  'thichanthit.com',
  'mentonit.net',
  'labworld.org',
  'canfga.org',
  'ema-sofia.eu',
  'musiccode.me',
  'decabg.eu',
  'kellychibale-researchgroup-uct.com',
  'tmpnator.live',
  'ryteto.me',
  'storegmail.com',
  'amozix.com',
  'anypsd.com',
  'cevipsa.com',
  'cpav3.com',
  'maxric.com',
  'mocvn.com',
  'nuclene.com',
  'pianoman.anonaddy.com',
  'steveix.com',
  'tenvil.com',
  'tgvis.com',
  'unicsite.com',
]);
